import React from 'react';

function BreadCrumbAdmin(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='other_houses'>
        <mask
          id='mask0_6599_3122'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='16'
          height='16'
        >
          <rect id='Bounding box' width='16' height='16' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_6599_3122)'>
          <path
            id='Vector'
            d='M3.00043 13.6667V7.49361L1.75556 8.44875L1.1543 7.65133L8.00041 2.41675L14.8465 7.65133L14.2453 8.4385L13.0004 7.49361V13.6667H3.00043ZM4.00041 12.6667H12.0004V6.73338L8.00041 3.68338L4.00041 6.73338V12.6667Z'
            fill='#484848'
          />
        </g>
      </g>
    </svg>
  );
}

BreadCrumbAdmin.displayName = 'BreadCrumbAdmin';

export default BreadCrumbAdmin;
